import { __assign } from 'tslib';
import React, { useRef, useEffect } from 'react';
import cn from 'classnames';
import noUiSlider from 'nouislider';

var styles = {"component":"slider__component_1qpg8","size-2":"slider__size-2_1qpg8","size-4":"slider__size-4_1qpg8"};
require('./index.css')

var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-2',
    m: 'size-4',
    2: 'size-2',
    4: 'size-4',
};
var Slider = function (_a) {
    var _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 100 : _c, _d = _a.step, step = _d === void 0 ? 1 : _d, _e = _a.value, value = _e === void 0 ? 0 : _e, valueTo = _a.valueTo, disabled = _a.disabled, pips = _a.pips, _f = _a.behaviour, behaviour = _f === void 0 ? 'tap' : _f, _g = _a.range, range = _g === void 0 ? { min: min, max: max } : _g, _h = _a.size, size = _h === void 0 ? 2 : _h, className = _a.className, onChange = _a.onChange, onStart = _a.onStart, onEnd = _a.onEnd, dataTestId = _a.dataTestId;
    var sliderRef = useRef(null);
    var busyRef = useRef(false);
    var hasValueTo = valueTo !== undefined;
    var getSlider = function () { var _a; return (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.noUiSlider; };
    useEffect(function () {
        if (!sliderRef.current)
            return;
        var slider = noUiSlider.create(sliderRef.current, {
            start: valueTo ? [value, valueTo] : value,
            connect: valueTo ? true : [true, false],
            behaviour: behaviour,
            step: step,
            pips: pips,
            range: range,
        });
        // eslint-disable-next-line consistent-return
        return function () { return slider.destroy(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var slider = getSlider();
        if (!slider)
            return;
        slider.on('start', function () {
            busyRef.current = true;
            onStart === null || onStart === void 0 ? void 0 : onStart();
        });
        slider.on('change', function () {
            busyRef.current = false;
            onEnd === null || onEnd === void 0 ? void 0 : onEnd();
        });
        // eslint-disable-next-line consistent-return
        return function () {
            slider.off('start');
            slider.off('change');
        };
    }, [onStart, onEnd]);
    useEffect(function () {
        var slider = getSlider();
        if (!slider)
            return;
        slider.updateOptions({
            step: step,
            range: range,
            pips: pips,
        }, true);
    }, [pips, range, step]);
    useEffect(function () {
        var slider = getSlider();
        // Пропускаем обновление, если происходит взаимодействие со слайдером
        if (slider && busyRef.current === false) {
            if (valueTo) {
                slider.set([value, valueTo], false);
            }
            else {
                slider.set(value, false);
            }
        }
    }, [value, valueTo]);
    useEffect(function () {
        var slider = getSlider();
        if (!slider)
            return;
        var handler = function () {
            if (onChange) {
                if (hasValueTo) {
                    var sliderValues = slider.get();
                    var from = Number(sliderValues[0]);
                    var to = Number(sliderValues[1]);
                    if (from <= to) {
                        onChange({ value: from, valueTo: to });
                    }
                    else {
                        onChange({ value: to, valueTo: from });
                    }
                }
                else {
                    onChange({ value: Number(slider.get()) });
                }
            }
        };
        slider.off('slide');
        slider.on('slide', handler);
    }, [onChange, hasValueTo]);
    return (React.createElement("div", __assign({ className: cn(styles.component, className, styles[SIZE_TO_CLASSNAME_MAP[size]]), ref: sliderRef, "data-test-id": dataTestId }, { disabled: disabled })));
};

export { SIZE_TO_CLASSNAME_MAP, Slider };
